
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dicas/[slug]",
      function () {
        return require("private-next-pages/dicas/[slug].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dicas/[slug]"])
      });
    }
  